// extracted by mini-css-extract-plugin
export default {"root":"fullPageContent_root__heStY","inner":"fullPageContent_inner__YkUkw","stripes-animation-background-keyframes":"fullPageContent_stripes-animation-background-keyframes__LZeHZ"};